import { render } from "./PanelAdminNews.vue?vue&type=template&id=1906a838&ts=true"
import script from "./PanelAdminNews.vue?vue&type=script&lang=ts"
export * from "./PanelAdminNews.vue?vue&type=script&lang=ts"

import "./PanelAdminNews.vue?vue&type=style&index=0&id=1906a838&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__